import bouncyArc from '../elements/bouncyArc.js';
bouncyArc.register();
